import chairfront from '../images/chairfront.jpg'
const Data = [
  {
    id: "f001",
    name: "Modern Wooden Chair",
    brand: "FurniStyle",
    category: "Chairs",
    description:
      "Ergonomically designed wooden chair perfect for living rooms and offices.",
    price: 149.99,
    discount: 10,
    finalPrice: 134.99,
    stock: 25,
    availability: "In Stock",
    material: "Solid Oak Wood",
    colorOptions: ["neutral", "amber", "gray"],
    dimensions: {
      height: "85 cm",
      width: "50 cm",
      depth: "55 cm",
    },
    weight: "7 kg",
    features: ["Ergonomic Design", "Durable Finish", "Easy Assembly"],
    ratings: 4.5,
    reviewsCount: 27,
    images: [
      chairfront,
      "https://m.media-amazon.com/images/I/41QfNr3zzYL.jpg",
      "https://m.media-amazon.com/images/I/31sQveMyTbL.jpg",
    ],
    warranty: "1 year",
    deliveryTime: "3-5 business days",
    returnPolicy: "30-day free returns",
    isFeatured: true,
    tags: ["living room", "wooden", "chair", "furniture"],
  },

  {
    id: "f002",
    name: "Contemporary Sofa",
    brand: "ComfyHome",
    category: "Sofas",
    description:
      "Comfortable three-seater sofa with high-quality fabric upholstery.",
    price: 499.99,
    discount: 15,
    finalPrice: 424.99,
    stock: 10,
    availability: "In Stock",
    material: "Linen Fabric",
    colorOptions: ["gray", "blue", "red"],
    dimensions: {
      height: "90 cm",
      width: "200 cm",
      depth: "95 cm",
    },
    weight: "30 kg",
    features: ["Plush Cushions", "Sturdy Frame", "Removable Covers"],
    ratings: 4.8,
    reviewsCount: 53,
    images: [
      "https://m.media-amazon.com/images/I/71fY6ArZ5sL.jpg",
      "https://m.media-amazon.com/images/I/814M7F-5IeL.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "15-day return policy",
    isFeatured: false,
    tags: ["sofa", "living room", "fabric"],
  },

  {
    id: "f003",
    name: "Minimalist Coffee Table",
    brand: "UrbanLiving",
    category: "Tables",
    description: "Elegant coffee table with tempered glass top and metal legs.",
    price: 199.99,
    discount: 20,
    finalPrice: 159.99,
    stock: 18,
    availability: "In Stock",
    material: "Tempered Glass & Steel",
    colorOptions: ["white", "black", "slate"],
    dimensions: {
      height: "45 cm",
      width: "120 cm",
      depth: "60 cm",
    },
    weight: "12 kg",
    features: ["Scratch Resistant", "Easy to Clean", "Modern Design"],
    ratings: 4.3,
    reviewsCount: 38,
    images: [
      "https://m.media-amazon.com/images/I/71Rgy61kSAL.jpg",
      "https://m.media-amazon.com/images/I/61-Z6uGQMqL.jpg",
    ],
    warranty: "6 months",
    deliveryTime: "2-4 business days",
    returnPolicy: "7-day return policy",
    isFeatured: true,
    tags: ["table", "modern", "glass"],
  },
  {
    id: "f004",
    name: "Vintage Bookshelf",
    brand: "RusticDecor",
    category: "Storage",
    description: "Classic wooden bookshelf with multiple storage sections.",
    price: 249.99,
    discount: 12,
    finalPrice: 219.99,
    stock: 15,
    availability: "In Stock",
    material: "Pine Wood",
    colorOptions: ["amber", "brown", "stone"],
    dimensions: {
      height: "180 cm",
      width: "80 cm",
      depth: "35 cm",
    },
    weight: "25 kg",
    features: ["Spacious Shelves", "Sturdy Build", "Vintage Finish"],
    ratings: 4.6,
    reviewsCount: 22,
    images: [
      "https://m.media-amazon.com/images/I/61IlOLjiV-L.jpg",
      "https://m.media-amazon.com/images/I/51R2-JyoX0L.jpg",
    ],
    warranty: "1 year",
    deliveryTime: "4-6 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["bookshelf", "wooden", "storage"],
  },
  {
    id: "f005",
    name: "Elegant Dining Table",
    brand: "EliteFurniture",
    category: "Dining",
    description: "Spacious dining table that comfortably seats six people.",
    price: 599.99,
    discount: 18,
    finalPrice: 491.99,
    stock: 8,
    availability: "Limited Stock",
    material: "Mahogany Wood",
    colorOptions: ["rose", "neutral", "gray"],
    dimensions: {
      height: "75 cm",
      width: "180 cm",
      depth: "90 cm",
    },
    weight: "40 kg",
    features: ["Durable Finish", "Easy Maintenance", "Modern Look"],
    ratings: 4.7,
    reviewsCount: 45,
    images: [
      "https://m.media-amazon.com/images/I/81ZPIetbO5L.jpg",
      "https://m.media-amazon.com/images/I/91Qz5y1HT3L.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "6-8 business days",
    returnPolicy: "No returns accepted",
    isFeatured: true,
    tags: ["dining", "wooden", "table"],
  },
  {
    id: "f006",
    name: "Luxury Recliner Chair",
    brand: "RelaxZone",
    category: "Chairs",
    description:
      "Premium recliner with adjustable positions and soft leather upholstery.",
    price: 299.99,
    discount: 20,
    finalPrice: 239.99,
    stock: 12,
    availability: "In Stock",
    material: "Genuine Leather",
    colorOptions: ["stone", "rose", "gray"],
    dimensions: {
      height: "100 cm",
      width: "85 cm",
      depth: "90 cm",
    },
    weight: "20 kg",
    features: ["Adjustable Backrest", "Soft Cushioning", "Durable Build"],
    ratings: 4.9,
    reviewsCount: 65,
    images: [
      "https://m.media-amazon.com/images/I/71JGtGtJz8L.jpg",
      "https://m.media-amazon.com/images/I/61dR4mfFAbL.jpg",
    ],
    warranty: "3 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: true,
    tags: ["recliner", "leather", "living room"],
  },
  {
    id: "f007",
    name: "Compact Office Desk",
    brand: "WorkEase",
    category: "Desks",
    description:
      "Space-saving office desk with built-in drawers and cable management system.",
    price: 179.99,
    discount: 15,
    finalPrice: 152.99,
    stock: 20,
    availability: "In Stock",
    material: "Engineered Wood",
    colorOptions: ["neutral", "amber", "slate"],
    dimensions: {
      height: "75 cm",
      width: "120 cm",
      depth: "60 cm",
    },
    weight: "18 kg",
    features: ["Built-in Drawers", "Easy Assembly", "Cable Organizer"],
    ratings: 4.4,
    reviewsCount: 33,
    images: [
      "https://m.media-amazon.com/images/I/51IuXI3mIlL.jpg",
      "https://m.media-amazon.com/images/I/51398L19OuL.jpg",
    ],
    warranty: "1 year",
    deliveryTime: "3-5 business days",
    returnPolicy: "15-day return policy",
    isFeatured: false,
    tags: ["desk", "office", "compact"],
  },
  {
    id: "f008",
    name: "Modern Bed Frame",
    brand: "SleepWell",
    category: "Beds",
    description:
      "Sturdy bed frame with headboard and under-bed storage options.",
    price: 399.99,
    discount: 18,
    finalPrice: 327.99,
    stock: 9,
    availability: "Limited Stock",
    material: "Solid Pine Wood",
    colorOptions: ["gray", "amber", "slate"],
    dimensions: {
      height: "110 cm",
      width: "160 cm",
      depth: "200 cm",
    },
    weight: "35 kg",
    features: ["Under-bed Storage", "Durable Design", "Comfortable Headboard"],
    ratings: 4.7,
    reviewsCount: 42,
    images: [
      "https://m.media-amazon.com/images/I/71jfKKBlHDL.jpg",
      "https://m.media-amazon.com/images/I/61enmBIY0yL.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "6-8 business days",
    returnPolicy: "No returns accepted",
    isFeatured: true,
    tags: ["bed", "wooden", "storage"],
  },
  {
    id: "f009",
    name: "Stylish Floor Lamp",
    brand: "BrightHome",
    category: "Lighting",
    description:
      "Contemporary floor lamp with adjustable brightness and metal finish.",
    price: 89.99,
    discount: 10,
    finalPrice: 80.99,
    stock: 30,
    availability: "In Stock",
    material: "Metal & Fabric",
    colorOptions: ["black", "amber", "white"],
    dimensions: {
      height: "160 cm",
      width: "35 cm",
      depth: "35 cm",
    },
    weight: "6 kg",
    features: ["Adjustable Brightness", "Sturdy Base", "Modern Design"],
    ratings: 4.5,
    reviewsCount: 29,
    images: [
      "https://m.media-amazon.com/images/I/71tQ1gNgqfL.jpg",
      "https://m.media-amazon.com/images/I/71Yx+PY2Z6L.jpg",
    ],
    warranty: "1 year",
    deliveryTime: "2-4 business days",
    returnPolicy: "7-day return policy",
    isFeatured: false,
    tags: ["lamp", "lighting", "modern"],
  },
  {
    id: "f010",
    name: "Outdoor Patio Set",
    brand: "OutdoorLux",
    category: "Outdoor",
    description: "Weather-resistant patio set with table and four chairs.",
    price: 549.99,
    discount: 22,
    finalPrice: 428.99,
    stock: 7,
    availability: "In Stock",
    material: "Wicker & Tempered Glass",
    colorOptions: ["stone", "green", "gray"],
    dimensions: {
      height: "75 cm",
      width: "150 cm",
      depth: "90 cm",
    },
    weight: "28 kg",
    features: [
      "Weather Resistant",
      "Comfortable Cushions",
      "Durable Glass Top",
    ],
    ratings: 4.8,
    reviewsCount: 50,
    images: [
      "https://m.media-amazon.com/images/I/71a6LKu90SL.jpg",
      "https://m.media-amazon.com/images/I/717MpfASyVL.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: true,
    tags: ["patio", "outdoor", "furniture"],
  },
  {
    id: "f011",
    name: "Luxury Velvet Sofa",
    brand: "LuxuryHome",
    category: "Sofas",
    description: "Elegant velvet sofa with deep cushions for ultimate comfort.",
    price: 599.99,
    discount: 15,
    finalPrice: 509.99,
    stock: 12,
    availability: "In Stock",
    material: "Velvet Upholstery & Hardwood Frame",
    colorOptions: ["navy", "emerald", "gray"],
    dimensions: {
      height: "90 cm",
      width: "210 cm",
      depth: "85 cm",
    },
    weight: "30 kg",
    features: ["Deep Cushions", "Modern Design", "Easy to Clean"],
    ratings: 4.8,
    reviewsCount: 45,
    images: [
      "https://m.media-amazon.com/images/I/31i9ee-+5aS.jpg",
      "https://m.media-amazon.com/images/I/31c+55Gs9mS.jpg",
      "https://m.media-amazon.com/images/I/318QtNwaZoS.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: true,
    tags: ["sofa", "luxury", "modern", "living room"],
  },
  {
    id: "f012",
    name: "Rustic Wooden Coffee Table",
    brand: "RusticCraft",
    category: "Tables",
    description: "Handcrafted wooden coffee table with a rich walnut finish.",
    price: 249.99,
    discount: 10,
    finalPrice: 224.99,
    stock: 20,
    availability: "In Stock",
    material: "Reclaimed Wood",
    colorOptions: ["walnut", "oak"],
    dimensions: {
      height: "45 cm",
      width: "120 cm",
      depth: "60 cm",
    },
    weight: "18 kg",
    features: ["Handcrafted", "Durable Build", "Eco-Friendly"],
    ratings: 4.6,
    reviewsCount: 38,
    images: [
      "https://m.media-amazon.com/images/I/61DRZ65JAbL.jpg",
      "https://m.media-amazon.com/images/I/415uVyxMR1L.jpg",
    ],
    warranty: "1 year",
    deliveryTime: "3-5 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["coffee table", "wood", "handmade", "rustic"],
  },
  {
    id: "f013",
    name: "Minimalist Wooden Bed Frame",
    brand: "NordicNest",
    category: "Beds",
    description: "Sturdy and sleek bed frame designed for a modern bedroom.",
    price: 699.99,
    discount: 12,
    finalPrice: 615.99,
    stock: 15,
    availability: "In Stock",
    material: "Solid Oak Wood",
    colorOptions: ["natural wood", "walnut"],
    dimensions: {
      height: "40 cm",
      width: "160 cm",
      depth: "200 cm",
    },
    weight: "35 kg",
    features: ["Sturdy Frame", "Sleek Design", "No Box Spring Needed"],
    ratings: 4.7,
    reviewsCount: 50,
    images: [
      "https://m.media-amazon.com/images/I/81BE8sGDanL.jpg",
      "https://m.media-amazon.com/images/I/51ueucYgoBL.jpg",
      "https://m.media-amazon.com/images/I/616KUxpEXML.jpg",
    ],
    warranty: "3 years",
    deliveryTime: "7-10 business days",
    returnPolicy: "60-day free returns",
    isFeatured: true,
    tags: ["bed", "wood", "modern", "minimalist"],
  },
  {
    id: "f014",
    name: "Classic Leather Recliner",
    brand: "ComfortZone",
    category: "Chairs",
    description: "Comfortable reclining chair with a plush leather finish.",
    price: 449.99,
    discount: 20,
    finalPrice: 359.99,
    stock: 10,
    availability: "In Stock",
    material: "Genuine Leather & Metal Base",
    colorOptions: ["black", "brown", "gray"],
    dimensions: {
      height: "110 cm",
      width: "85 cm",
      depth: "90 cm",
    },
    weight: "20 kg",
    features: ["Adjustable Recline", "Padded Armrests", "Ergonomic Design"],
    ratings: 4.8,
    reviewsCount: 42,
    images: [
      "https://m.media-amazon.com/images/I/81YT0-PAWTL.jpg",
      "https://m.media-amazon.com/images/I/61qIO4EjieL.jpg",
      "https://m.media-amazon.com/images/I/81A4N6MRBbL.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "4-6 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["recliner", "leather", "living room", "chair"],
  },
  {
    id: "f015",
    name: "Elegant Dining Set",
    brand: "DiningMaster",
    category: "Tables",
    description: "6-seater wooden dining set with a premium finish.",
    price: 799.99,
    discount: 10,
    finalPrice: 719.99,
    stock: 8,
    availability: "In Stock",
    material: "Solid Oak Wood",
    colorOptions: ["walnut", "natural wood"],
    dimensions: {
      height: "75 cm",
      width: "180 cm",
      depth: "90 cm",
    },
    weight: "40 kg",
    features: ["Elegant Finish", "Durable Build", "Seats 6 People"],
    ratings: 4.9,
    reviewsCount: 60,
    images: [
      "https://m.media-amazon.com/images/I/61oiZfHjM-L.jpg",
      "https://m.media-amazon.com/images/I/51lpNfDoPoL.jpg",
      "https://m.media-amazon.com/images/I/51FbKaQ7JVL.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "7-10 business days",
    returnPolicy: "60-day free returns",
    isFeatured: true,
    tags: ["dining table", "wood", "6-seater", "elegant"],
  },
  {
    id: "f016",
    name: "Scandinavian Lounge Chair",
    brand: "NordicNest",
    category: "Chairs",
    description: "Minimalist lounge chair with a soft fabric cushion.",
    price: 229.99,
    discount: 12,
    finalPrice: 202.39,
    stock: 15,
    availability: "In Stock",
    material: "Solid Beech Wood & Linen Fabric",
    colorOptions: ["gray", "blue", "beige"],
    dimensions: {
      height: "85 cm",
      width: "75 cm",
      depth: "80 cm",
    },
    weight: "12 kg",
    features: ["Soft Cushions", "Modern Look", "Ergonomic Design"],
    ratings: 4.6,
    reviewsCount: 35,
    images: [
      "https://m.media-amazon.com/images/I/51QR6PLv5DL.jpg",
      "https://m.media-amazon.com/images/I/41iaITaL7wL.jpg",
      "https://m.media-amazon.com/images/I/41MBRzumV3L.jpg",
    ],
    warranty: "1 year",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["lounge chair", "minimalist", "comfortable", "fabric"],
  },
  {
    id: "f017",
    name: "Industrial Bookshelf",
    brand: "UrbanLiving",
    category: "Tables",
    description: "5-tier bookshelf with a metal frame and rustic wood shelves.",
    price: 189.99,
    discount: 15,
    finalPrice: 161.49,
    stock: 20,
    availability: "In Stock",
    material: "Reclaimed Wood & Iron",
    colorOptions: ["dark oak", "walnut"],
    dimensions: {
      height: "180 cm",
      width: "90 cm",
      depth: "30 cm",
    },
    weight: "22 kg",
    features: ["Sturdy Build", "Rustic Finish", "5 Shelves"],
    ratings: 4.7,
    reviewsCount: 40,
    images: [
      "https://m.media-amazon.com/images/I/713M7ND785L.jpg",
      "https://m.media-amazon.com/images/I/41i5lsbP-uL.jpg",
      "https://m.media-amazon.com/images/I/71FVKMANnTL.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "3-5 business days",
    returnPolicy: "30-day free returns",
    isFeatured: true,
    tags: ["bookshelf", "industrial", "wood", "storage"],
  },
  {
    id: "f018",
    name: "Modern King Bed Frame",
    brand: "ComfortNest",
    category: "Beds",
    description: "Spacious king-size bed frame with a sleek design.",
    price: 899.99,
    discount: 10,
    finalPrice: 809.99,
    stock: 10,
    availability: "In Stock",
    material: "Solid Oak Wood & Upholstered Headboard",
    colorOptions: ["white", "gray", "black"],
    dimensions: {
      height: "50 cm",
      width: "200 cm",
      depth: "220 cm",
    },
    weight: "45 kg",
    features: ["Spacious Design", "Durable Frame", "Easy Assembly"],
    ratings: 4.8,
    reviewsCount: 55,
    images: [
      "https://m.media-amazon.com/images/I/61sYtf2HNdL.jpg",
      "https://m.media-amazon.com/images/I/41cH-SfjrJL.jpg",
      "https://m.media-amazon.com/images/I/51Xtv77RnML.jpg",
    ],
    warranty: "3 years",
    deliveryTime: "7-10 business days",
    returnPolicy: "60-day free returns",
    isFeatured: true,
    tags: ["bed", "modern", "king-size", "upholstered"],
  },
  {
    id: "f019",
    name: "Glass Top Office Desk",
    brand: "OfficePro",
    category: "Tables",
    description: "Sleek and modern office desk with a tempered glass top.",
    price: 349.99,
    discount: 8,
    finalPrice: 321.99,
    stock: 18,
    availability: "In Stock",
    material: "Tempered Glass & Steel Frame",
    colorOptions: ["black", "silver", "white"],
    dimensions: {
      height: "75 cm",
      width: "140 cm",
      depth: "60 cm",
    },
    weight: "20 kg",
    features: ["Spacious Work Area", "Sturdy Frame", "Minimalist Look"],
    ratings: 4.5,
    reviewsCount: 30,
    images: [
      "https://m.media-amazon.com/images/I/71FcLJ5nL3L.jpg",
      "https://m.media-amazon.com/images/I/41qRKH+A8zL.jpg",
      "https://m.media-amazon.com/images/I/41l85Qr9NQL.jpg",
    ],
    warranty: "2 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["office desk", "glass", "modern", "workspace"],
  },
  {
    id: "f020",
    name: "Reclining Leather Sofa",
    description: "Luxurious reclining leather sofa with adjustable settings.",
    category: "Sofas",
    price: 1099.99,
    discount: 18,
    finalPrice: 901.99,
    ratings: 4.9,
    reviewsCount: 65,
    images: [
      "https://m.media-amazon.com/images/I/61Sss2egLsL.jpg",
      "https://m.media-amazon.com/images/I/71wsLL7aqkL.jpg",
      "https://m.media-amazon.com/images/I/61LvDsKDGPL.jpg",
    ],
    stock: 5,
    material: "Genuine Leather & Metal Reclining Mechanism",
    colorOptions: ["brown", "black", "gray"],
    dimensions: { height: "95 cm", width: "220 cm", depth: "100 cm" },
    weight: "55 kg",
    features: ["Adjustable Recline", "Padded Armrests", "Premium Comfort"],
    brand: "LuxurySeating",
    warranty: "3 years",
    deliveryTime: "7-10 business days",
    returnPolicy: "60-day free returns",
    isFeatured: true,
    tags: ["sofa", "recliner", "leather", "luxury"],
    availability: "In Stock",
  },
  {
    id: "f021",
    name: "Vintage Wooden Coffee Table",
    description:
      "Rustic wooden coffee table with a sturdy build and elegant finish.",
    category: "Tables",
    price: 299.99,
    discount: 12,
    finalPrice: 263.99,
    ratings: 4.7,
    reviewsCount: 40,
    images: [
      "https://m.media-amazon.com/images/I/71blwkB0IlL.jpg",
      "https://m.media-amazon.com/images/I/51vJOJ+seAL.jpg",
      "https://m.media-amazon.com/images/I/71QKCPIYG1L.jpg",
    ],
    stock: 15,
    material: "Solid Pine Wood",
    colorOptions: ["walnut", "cherry", "natural wood"],
    dimensions: { height: "45 cm", width: "120 cm", depth: "60 cm" },
    weight: "18 kg",
    features: ["Vintage Look", "Durable Finish", "Scratch-Resistant"],
    brand: "RusticHome",
    warranty: "2 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["coffee table", "wood", "vintage", "rustic"],
    availability: "In Stock",
  },
  {
    id: "f022",
    name: "Ergonomic Office Chair",
    description:
      "Adjustable office chair with lumbar support and breathable mesh.",
    category: "Chairs",
    price: 199.99,
    discount: 15,
    finalPrice: 169.99,
    ratings: 4.8,
    reviewsCount: 55,
    images: [
      "https://m.media-amazon.com/images/I/7189J9lSmNL.jpg",
      "https://m.media-amazon.com/images/I/71q6KiwQ8yL.jpg",
      "https://m.media-amazon.com/images/I/81tRfiqnshL.jpg",
    ],
    stock: 20,
    material: "Mesh & Metal Base",
    colorOptions: ["black", "gray", "blue"],
    dimensions: { height: "120 cm", width: "65 cm", depth: "70 cm" },
    weight: "14 kg",
    features: ["Adjustable Height", "Breathable Mesh", "360° Swivel"],
    brand: "WorkEase",
    warranty: "1 year",
    deliveryTime: "3-5 business days",
    returnPolicy: "30-day free returns",
    isFeatured: true,
    tags: ["office chair", "ergonomic", "adjustable", "mesh"],
    availability: "In Stock",
  },
  {
    id: "f023",
    name: "Minimalist Floating Shelf Set",
    description: "Set of 3 wall-mounted floating shelves for a modern look.",
    category: "Tables",
    price: 89.99,
    discount: 10,
    finalPrice: 80.99,
    ratings: 4.6,
    reviewsCount: 30,
    images: [
      "https://m.media-amazon.com/images/I/61-Hhx66gOL.jpg",
      "https://m.media-amazon.com/images/I/71KsRft2mBL.jpg",
      "https://m.media-amazon.com/images/I/61gnTsYg4eL.jpg",
    ],
    stock: 30,
    material: "MDF Wood",
    colorOptions: ["white", "black", "oak"],
    dimensions: { height: "5 cm", width: "60 cm", depth: "20 cm" },
    weight: "3 kg",
    features: ["Wall-Mounted", "Space-Saving", "Modern Look"],
    brand: "HomeDecor",
    warranty: "1 year",
    deliveryTime: "3-5 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["shelves", "floating", "modern", "wall-mounted"],
    availability: "In Stock",
  },
  {
    id: "f024",
    name: "Luxury Velvet Sofa",
    description: "Premium 3-seater velvet sofa with plush cushions.",
    category: "Sofas",
    price: 1299.99,
    discount: 18,
    finalPrice: 1065.99,
    ratings: 4.9,
    reviewsCount: 70,
    images: [
      "https://m.media-amazon.com/images/I/51unSadtlIL.jpg",
      "https://m.media-amazon.com/images/I/41NdSZz8RlL.jpg",
      "https://m.media-amazon.com/images/I/31v1JGcSnJL.jpg",
    ],
    stock: 8,
    material: "Velvet Fabric & Hardwood Frame",
    colorOptions: ["emerald green", "navy blue", "burgundy"],
    dimensions: { height: "90 cm", width: "220 cm", depth: "100 cm" },
    weight: "50 kg",
    features: [
      "Soft Velvet Upholstery",
      "Elegant Design",
      "Deep Seating Comfort",
    ],
    brand: "LuxeLiving",
    warranty: "3 years",
    deliveryTime: "7-10 business days",
    returnPolicy: "60-day free returns",
    isFeatured: true,
    tags: ["sofa", "velvet", "luxury", "comfortable"],
    availability: "In Stock",
  },
  {
    id: "f025",
    name: "Space-Saving Foldable Bed",
    description: "Single bed with a foldable frame for compact spaces.",
    category: "Beds",
    price: 499.99,
    discount: 12,
    finalPrice: 439.99,
    ratings: 4.7,
    reviewsCount: 50,
    images: [
      "https://m.media-amazon.com/images/I/51DnySp8R3L.jpg",
      "https://m.media-amazon.com/images/I/61oAVfoyIGL.jpg",
      "https://m.media-amazon.com/images/I/71M-wxoKf5L.jpg",
    ],
    stock: 12,
    material: "Metal Frame & Memory Foam Mattress",
    colorOptions: ["gray", "black"],
    dimensions: { height: "40 cm", width: "90 cm", depth: "200 cm" },
    weight: "25 kg",
    features: ["Foldable Design", "Memory Foam Comfort", "Easy Storage"],
    brand: "CompactLiving",
    warranty: "2 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["bed", "foldable", "space-saving", "single bed"],
    availability: "In Stock",
  },
  {
    id: "f026",
    name: "Scandinavian Lounge Chair",
    description: "Elegant lounge chair with a minimalist Scandinavian design.",
    category: "Chairs",
    price: 249.99,
    discount: 15,
    finalPrice: 212.49,
    ratings: 4.8,
    reviewsCount: 38,
    images: [
      "https://m.media-amazon.com/images/I/71jlmFy4puL.jpg",
      "https://m.media-amazon.com/images/I/61vgVxHckwL.jpg",
      "https://m.media-amazon.com/images/I/71F6yhd61qL.jpg",
    ],
    stock: 20,
    material: "Beech Wood & Linen Upholstery",
    colorOptions: ["beige", "gray", "charcoal"],
    dimensions: { height: "90 cm", width: "70 cm", depth: "75 cm" },
    weight: "12 kg",
    features: ["Ergonomic Design", "Soft Cushions", "Modern Aesthetic"],
    brand: "NordicLiving",
    warranty: "2 years",
    deliveryTime: "3-5 business days",
    returnPolicy: "30-day free returns",
    isFeatured: true,
    tags: ["lounge chair", "minimalist", "comfortable", "modern"],
    availability: "In Stock",
  },
  {
    id: "f027",
    name: "Mid-Century Modern TV Stand",
    description: "Stylish wooden TV stand with storage compartments.",
    category: "Tables",
    price: 399.99,
    discount: 10,
    finalPrice: 359.99,
    ratings: 4.6,
    reviewsCount: 45,
    images: [
      "https://m.media-amazon.com/images/I/613FFSFiYxL.jpg",
      "https://m.media-amazon.com/images/I/51BeHd3MO1L.jpg",
      "https://m.media-amazon.com/images/I/41SnCTiysXL.jpg",
    ],
    stock: 15,
    material: "Walnut Wood & MDF",
    colorOptions: ["walnut", "white", "black"],
    dimensions: { height: "50 cm", width: "150 cm", depth: "40 cm" },
    weight: "22 kg",
    features: ["Cable Management", "Soft-Closing Drawers", "Sleek Finish"],
    brand: "UrbanHome",
    warranty: "2 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["tv stand", "storage", "mid-century", "wooden"],
    availability: "In Stock",
  },
  {
    id: "f028",
    name: "Convertible Sleeper Sofa",
    description: "Multi-functional sofa that converts into a bed.",
    category: "Sofas",
    price: 899.99,
    discount: 20,
    finalPrice: 719.99,
    ratings: 4.7,
    reviewsCount: 65,
    images: [
      "https://m.media-amazon.com/images/I/513cvG6TcBL.jpg",
      "https://m.media-amazon.com/images/I/51YxfGes+iL.jpg",
      "https://m.media-amazon.com/images/I/61wT1WSoWqL.jpg",
    ],
    stock: 10,
    material: "Microfiber & Metal Frame",
    colorOptions: ["dark gray", "navy blue", "taupe"],
    dimensions: { height: "85 cm", width: "200 cm", depth: "95 cm" },
    weight: "45 kg",
    features: ["Easy Conversion", "Plush Comfort", "Space-Saving"],
    brand: "HomeFlex",
    warranty: "3 years",
    deliveryTime: "7-10 business days",
    returnPolicy: "60-day free returns",
    isFeatured: true,
    tags: ["sofa bed", "convertible", "space-saving", "multi-functional"],
    availability: "In Stock",
  },
  {
    id: "f029",
    name: "Industrial Style Bookshelf",
    description: "Metal and wood bookshelf with five spacious shelves.",
    category: "Tables",
    price: 329.99,
    discount: 12,
    finalPrice: 290.39,
    ratings: 4.5,
    reviewsCount: 32,
    images: [
      "https://m.media-amazon.com/images/I/81o4dLPn4DL.jpg",
      "https://m.media-amazon.com/images/I/71jmkuBIT9L.jpg",
      "https://m.media-amazon.com/images/I/81W3QM26INL.jpg",
    ],
    stock: 18,
    material: "Metal Frame & Oak Shelves",
    colorOptions: ["black & oak", "white & walnut"],
    dimensions: { height: "180 cm", width: "80 cm", depth: "35 cm" },
    weight: "20 kg",
    features: ["Rustic Finish", "Heavy-Duty Build", "Open Shelving"],
    brand: "UrbanRustic",
    warranty: "2 years",
    deliveryTime: "5-7 business days",
    returnPolicy: "30-day free returns",
    isFeatured: false,
    tags: ["bookshelf", "industrial", "storage", "home decor"],
    availability: "In Stock",
  },
  {
    id: "f030",
    name: "Luxury King-Size Bed Frame",
    description: "Elegant king-size bed frame with a soft fabric headboard.",
    category: "Beds",
    price: 1299.99,
    discount: 18,
    finalPrice: 1065.99,
    ratings: 4.9,
    reviewsCount: 80,
    images: [
      "https://m.media-amazon.com/images/I/81S440uYKLL.jpg",
      "https://m.media-amazon.com/images/I/61w0HzL+KeL.jpg",
      "https://m.media-amazon.com/images/I/61Oj0+Rb7ZL.jpg",
    ],
    stock: 8,
    material: "Solid Wood & Upholstered Fabric",
    colorOptions: ["gray", "cream", "navy blue"],
    dimensions: { height: "120 cm", width: "210 cm", depth: "220 cm" },
    weight: "55 kg",
    features: ["Soft Fabric Headboard", "Durable Wood Frame", "Elegant Design"],
    brand: "LuxuryNest",
    warranty: "3 years",
    deliveryTime: "7-10 business days",
    returnPolicy: "60-day free returns",
    isFeatured: true,
    tags: ["bed frame", "king size", "luxury", "upholstered"],
    availability: "In Stock",
  },
];
export default Data;
